const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// When loaded and if the user doesn't want animations disabled
document.addEventListener('DOMContentLoaded', (event) => {
    if( !prefersReducedMotion ){

        // Setup the animation observer
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry) => {
                if( entry.isIntersecting ){
                    let delay = entry.target.dataset.animationDelay ?? 0;
                    setTimeout(()=>{
                        entry.target.dataset.hasAnimated = true;
                    }, delay);
                }
            });
        }, {
            threshold: 0.1
        });

        // Look for the animation tags and register everything with the observer
        document.querySelectorAll('[data-animation]').forEach((el)=>{
            console.log('el', el)
            el.dataset.hasAnimated = el.getClientRects()[0].top - window.innerHeight <= 0; // Only on down, never on
            observer.observe(el)
        })

        // Trigger an initial firing of the auto-delay processor
        updateAnimatedStationAutoDelay()
    }
});

// Groups all the elements by their Y pos, then adds the needed delay
function updateAnimatedStationAutoDelay() {

    // Grab all the elements
    let autoDelayElements = {};
    document.querySelectorAll('[data-animation-auto-delay]').forEach((el)=>{
        const elOffset = el.getBoundingClientRect().top
        if( autoDelayElements[elOffset] === undefined ){
            autoDelayElements[elOffset] = []
        }
        autoDelayElements[elOffset].push(el)
    });

    // Process those elements
    Object.keys(autoDelayElements).forEach((key)=>{
        autoDelayElements[key].forEach((el, n)=>{
            const delayBy = parseInt(el.dataset.animationAutoDelay) ?? 0;
            el.dataset.animationDelay = n*delayBy;
        })
    })
}

// And on resize those things can change so re-math it
window.onresize = () => {
    updateAnimatedStationAutoDelay();
}
